<div class="emds">
    <div class="modal-header">
      <span translate>{{title}}</span>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-12">
          <ap-select>
            <select class="form-control"
                    id="{{Id}}-dropdown"
                    [(ngModel)]="selectedTimeFrame"
                    (change)="onTimeFrameChange()">
              <option [ngValue]=null>Select a Timeframe</option>
              <option *ngFor="let timeFrame of timeFrameDtos"
                      [ngValue]="timeFrame">{{timeFrame.Name}}
              </option>
            </select>
          </ap-select>
        </div>
      </div>
      <div *ngIf="typeSelected && (isNumber || isDefault || isFreeText || isCalendar)" class="row">
        <hr />
        <div class="col-sm-12">
          <div *ngIf="isCalendar">
            <div class="input-group">
                <input type="text" class="form-control"
                  #dateInput
                  id="{{baseId}}-date"
                  name="{{baseId}}-datePicker"
                  placeholder="Date"
                  bsDatepicker
                  [bsValue]="dateValue"
                  [bsConfig]="bsConfig"
                  [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="dateValue"
                  (ngModelChange)='onValueChange()'
                  placement="right"
                  #timeFrameDatePicker="bsDatepicker"
                  [readonly]="false">
                <span class="input-group-btn">
                    <button type="button" class="date-btn btn btn-default btn-flush" id="{{baseId}}-datePicker"
                        (click)="timeFrameDatePicker.toggle()">
                        <i class="glyphicon glyphicon-calendar date-icon"></i>
                    </button>
                </span>
            </div>
          </div>
          <div *ngIf="isFreeText">
            <input #textInput type="text" [(ngModel)]="textValue" class="form-control" (ngModelChange)='onValueChange()'>
          </div>
          <div *ngIf="isDefault">
            <input #textInput (keypress)="filterEntry($event)" (input)="replaceEntry($event)" type="text" [(ngModel)]="textValue" class="form-control" (ngModelChange)='onValueChange()'>
          </div>
          <div *ngIf="isNumber && selectedTimeFrame" class="ap-timeframe-numeric-input">
            <mat-form-field appearance="outline">
              <input #numberInput matInput type="number" [(ngModel)]="numericValue" (ngModelChange)='onValueChange()'>
              <span matSuffix>{{selectedTimeFrame.Name}}</span>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button id="{{Id}}-cancel"
              class="btn btn-secondary pull-right btn-flush-right"
              (click)="cancel()"
              translate>Cancel</button>
      <button form="macro-editor-form"
              id="{{Id}}-save"
              class="btn btn-primary pull-right"
              (click)="close()"
              [disabled]="!canSave"
              translate>Save</button>
    </div>
</div>
